import React, { useState, useEffect, useRef } from 'react';
import { ListItem } from './ListItem';
import { TargetEvent } from '../../constants/enums';
import { ListInt } from './DropdownWithList';
type HTMLElementEvent<T extends HTMLElement> = Event & {
    target: T;
}

export interface ListProps {
    list: Array<ListInt>,
    setValue: Function,
    value: string,
    display: boolean,
    setDisplay: Function
}

export const List = ({ ...props }: ListProps) => {
    const [activeVal, setActiveVal] = useState<string>(props.value ? props.value : '');
    const [offScreen, setOffScreen] = useState<string>('')
    const listRef = useRef<any>(null);

    function handleClickOutside(event: any) {
        if (listRef.current && !listRef.current.contains(event.target) && event.target.id != "dropdownButton" && event.target.id != "dropdownChevron") {
            props.setDisplay(false);
        }
    }

    useEffect(() => {
        document.addEventListener(TargetEvent.Mousedown, handleClickOutside);
        document.addEventListener(TargetEvent.Keyup, handleClickOutside);
        return () => {
            document.removeEventListener(TargetEvent.Mousedown, handleClickOutside);
            document.removeEventListener(TargetEvent.Keyup, handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setActiveVal(props.value)
    }, [props.value]);

    const checkOffscreen = () => {
        if (listRef && listRef.current && document) {
            const elem = listRef.current.getBoundingClientRect();
            if (elem.bottom >= document.documentElement.clientHeight) {
                setOffScreen('off');
            }
            else if (elem.top < 0) {
                setOffScreen('');
            }
        }
    };

    useEffect(() => {
        if (window) {
            window.addEventListener('resize', checkOffscreen, { passive: true });
            window.addEventListener('scroll', checkOffscreen, { passive: true });
        }
        return () => {
            if (window) {
                window.removeEventListener('resize', checkOffscreen);
                window.removeEventListener('scroll', checkOffscreen);
            }
        }
    }, []);

    useEffect(() => {
        checkOffscreen();
    }, []);

    function onSelect(event: any) {
        event.preventDefault();
        event.stopPropagation();
        const val = event.target.getAttribute('data-value');
        const text = event.target.textContent;
        setActiveVal(val!);
        props.setValue && props.setValue(val, text);
        if (event.key === TargetEvent.Enter) {
            const parBtn = event.target.parentNode;
            const grandPar = parBtn.parentNode.previousElementSibling;
            grandPar?.focus();
        }
    }


    return (
        <ul className={"list-menu " + (props.display ? `${offScreen} display-list` : props.display === false ? `${offScreen} hide-list` : `${offScreen} display-list`)} ref={listRef}>
            {props.list.map((item: ListInt) => <ListItem value={item.value} text={item.text} activeValue={activeVal} key={'list' + item.value} onClick={onSelect} />)}
        </ul>
    );
}